export interface PresetPalette {
  name: string;
  primary: string;
  secondary: string;
}

// Curated fallback palettes for when the logo's extracted colors aren't
// usable as brand colors (e.g. a white/black/monochrome logo).
export const PRESET_PALETTES: PresetPalette[] = [
  { name: "Ocean", primary: "#0EA5E9", secondary: "#22D3EE" },
  { name: "Sunset", primary: "#F97316", secondary: "#FB7185" },
  { name: "Violet", primary: "#8B5CF6", secondary: "#EC4899" },
  { name: "Forest", primary: "#16A34A", secondary: "#84CC16" },
  { name: "Berry", primary: "#DB2777", secondary: "#F43F5E" },
  { name: "Slate", primary: "#334155", secondary: "#64748B" },
  { name: "Amber", primary: "#D97706", secondary: "#FACC15" },
  { name: "Indigo", primary: "#4F46E5", secondary: "#818CF8" },
  { name: "Teal", primary: "#0D9488", secondary: "#2DD4BF" },
  { name: "Crimson", primary: "#DC2626", secondary: "#F87171" },
];
